import { TableCell } from "@mui/material";
import { UserProfileTitleName } from "../../pages/UserManagement/UserManagementBody/UserProfile/UserProfile.styles";

export interface AccountTableHeadProp {
  title: string;
  width: string;
}
const AccountTableHead: React.FC<AccountTableHeadProp> = ({ title, width }) => {
  return (
    <>
      <TableCell sx={{ width }}>
        <span style={{ color: "#5E5E5E" }}>{title}</span>
      </TableCell>
    </>
  );
};

export default AccountTableHead;
